import {Component, HostListener, OnInit} from '@angular/core';
import {LayoutService} from 'src/app/layout/service/app.layout.service';
import {LoginServices} from './services/login.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import {UserMenuService} from "./services/usermenu.service";
import {RandomSessionIdService} from "../../guards/random-session-id.service";
import {TramitePagosService} from "../../users/pagos/services/tramite-pagos.service";
import LogRocket from "logrocket";
import {HttpParams} from "@angular/common/http";
import {environment} from "../../../environments/environment.development";
import {GalleriaModule} from 'primeng/galleria';
import Swal from 'sweetalert2';

@Component({
    templateUrl: './login.component.html',
    providers: [MessageService, GalleriaModule, ConfirmationService],
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
    sessionId: string | null
    public usuario: string = null!
    public password: string = null!
    public camposCompletos: boolean = false
    deshabilitarLogin: boolean = false
    mostrarLoginSV: boolean = environment.mostrarLoginSV
    registerSent: boolean = false
    loading: boolean = false;
    images: string[] = [];
    activeIndex: number = 0;

    constructor(private userMenuService: UserMenuService, public rs: RandomSessionIdService, private layoutService: LayoutService,
                public loginServices: LoginServices, private route: ActivatedRoute, private router: Router,
                private messageService: MessageService, private tramitePagosService: TramitePagosService, private confirmationService: ConfirmationService) {
        this.sessionId = rs.randomSessionId();
    }

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.preFetchRegisterSent();
        this.layoutService.onConfigUpdate()
        this.loadGalleria();
    }

    private loadGalleria() {
        this.images = [
            'assets/demo/images/galleria/Centro Historico atardecer.jpg',
            'assets/demo/images/galleria/Apopa.jpg',
            'assets/demo/images/galleria/El Zonte.jpg',
            'assets/demo/images/galleria/Ilopango San Salvador Este.jpg',
            'assets/demo/images/galleria/Playa Las Flores.jpg',
            'assets/demo/images/galleria/San Felipe, San Vicente Norte.jpg',
            'assets/demo/images/galleria/Suchitoto.jpg'
        ];
    }

    login() {
        this.resetGlobalStates();
        this.deshabilitarLogin = true
        this.camposCompletos = true
        this.loading = true
        console.log(`this.usuario -->${this.usuario}, this.password -->********`);
        this.loginServices.login(this.usuario.trim(), this.password.trim())
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        if (result.status == 200) {
                            this.loginServices.session.set(result.body!)
                            if (this.loginServices.isValid) {
                                this.loginServices.sessionExpirationMonitor();
                            }
                            if (this.loginServices.session()?.perfil == null || this.loginServices.session()?.perfil?.usuario == undefined) {
                                this.messageService.add({
                                    severity: 'error',
                                    summary: '',
                                    detail: 'Credenciales Inválidas'
                                });
                                setTimeout(() => {
                                    this.deshabilitarLogin = false
                                    this.loading = false
                                }, 1000);
                                return;
                            }
                            LogRocket.identify(this.loginServices.session()?.perfil?.uniqueId!, {
                                name: this.loginServices.session()?.perfil?.usuario!
                            });
                            LogRocket.track("login_success");
                            this.userMenuService.getMenusPorRol(this.userMenuService.getUniqueIDs(result.body.perfil.roles))
                            this.router.navigate([this.loginServices.getDefaultRoute(result.body.perfil)])
                        }
                    }
                },
                error: (error) => {
                    LogRocket.captureException(error, {
                        tags: {
                            type: 'login_attempt',
                        },
                        extra: {
                            pageName: 'login_page',
                        },
                    });
                    console.log(error)
                    // this.messageService.add({
                    //     severity: 'error',
                    //     summary: '',
                    //     detail: 'Credenciales Inválidas'
                    // });
                    Swal.fire({
                        icon: 'error',
                        title: 'Credenciales Inválidas',
                        text: 'Usuario y/o contraseña inválidas',
                        confirmButtonText: 'Aceptar'
                    });
                    setTimeout(() => {
                        this.deshabilitarLogin = false
                        this.loading = false
                    }, 1000);
                },
                complete: () => {
                    setTimeout(() => {
                        this.deshabilitarLogin = false
                        this.loading = false
                    }, 1000);
                }
            });
    }

    confirmarLoginSV() {
        this.confirmationService.confirm({
            message: 'Identidad Digital es únicamente para personas naturales. ¿Desea continuar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí, continuar',
            rejectLabel: 'Cancelar',
            accept: () => {
                this.loginSV(); // Llama tu función original
            },
            reject: () => {
                // Opcional: manejar rechazo
            }
        });
    }

    loginSV() {
        const params = new HttpParams()
            .set('response_type', environment.responseTypeID)
            .set('client_id', environment.clientID)
            .set('redirect_uri', environment.redirectURI);
        window.location.href = environment.hostID + environment.endpointAuthorizeID + '?' + params.toString();
    }

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeyPress(event: KeyboardEvent) {
        this.login();
    }

    get logoCNR(): any {
        if (this.layoutService.config.colorScheme != undefined) {
            if (this.layoutService.config.colorScheme == "light") {
                return 'assets/demo/images/logos/dot_logo.png'
            } else if (this.layoutService.config.colorScheme == "dark") {
                return 'assets/demo/images/dashboard/dot_logo.png'
            }
        }
    }

    private preFetchRegisterSent() {
        const queryParams = {...this.route.snapshot.queryParams};
        if (queryParams.hasOwnProperty('registerSent')) {
            this.registerSent = true;
        }
    }

    private resetGlobalStates() {
        this.loginServices.removerSession('LoginComponent.resetGlobalStates');
        this.userMenuService.rutas.set([])
        this.tramitePagosService.resetState()
        sessionStorage.clear()
        localStorage.clear()
    }
}
